import * as client from "_graphql-types";
import * as types from "./types";

import { filterSortPage } from "../DataProvider";

type Sdk = ReturnType<typeof client.getSdk>;

/*********************************************************************/
// Data Provider Functions
/*********************************************************************/

/*********************************************************************/
async function getList(
  sdk: Sdk,
  params: types.GetListParams<client.OperatingStatusEnumSortEnum>
) {
  const { pagination, sort } = params;

  const {
    operatingStatusEnumList: { items: data, total },
  } = await sdk.getListOperatingStatusEnum(
    filterSortPage({ sort, pagination })
  );

  return {
    data,
    total,
  };
}

/*********************************************************************/
async function getOne(sdk: Sdk, params: types.GetOneParams) {
  const id = Number(params.id);
  const { operatingStatusEnum: data } = await sdk.getOneOperatingStatusEnum({
    id,
  });
  return {
    data,
  };
}

/*********************************************************************/
async function getMany(sdk: Sdk, params: types.GetManyParams) {
  const ids = params.ids.map(id => Number(id));

  const { operatingStatusEnumMany: data } =
    await sdk.getManyOperatingStatusEnum({
      ids,
    });

  return {
    data,
  };
}

/*********************************************************************/
export const operatingStatusEnum = types.dataProvider({
  getList,
  getOne,
  getMany,
  ttl: types.defaultEnumTtl,
});
